// Minimal ua-parser-js replacement covering exactly what bb-user-browser /
// bb-user-platform need: browser and OS name/version out of a stored
// user_agent string, limited to the icon vocabulary those components map
// (Chrome, Firefox, Opera, Safari, IE/Edge — Windows, Mac OS, Linux, Android,
// iOS, Blackberry). The vocabulary is CLOSED: anything outside it yields
// `{ name: undefined, version: undefined }` — an unrecognized name is never
// echoed back, because the callers turn `name` into an icon class and only
// have icons for the list above (they bucket `undefined` as 'Others').
function parseUserAgent(ua = '') {
  return {
    browser: detectBrowser(ua),
    os: detectOs(ua)
  };
}
function detectBrowser(ua) {
  // Order matters: Edge/Opera embed "Chrome", Chrome embeds "Safari".
  const rules = [{
    name: 'Edge',
    re: /(?:Edge|Edg|EdgA|EdgiOS)\/(\d+[\w.]*)/
  }, {
    name: 'Opera',
    re: /(?:OPR|Opera)[/ ](\d+[\w.]*)/
  }, {
    name: 'Chrome',
    re: /(?:Chrome|CriOS)\/(\d+[\w.]*)/
  }, {
    name: 'Firefox',
    re: /(?:Firefox|FxiOS)\/(\d+[\w.]*)/
  }, {
    name: 'IE',
    re: /(?:MSIE |Trident\/.*rv:)(\d+[\w.]*)/
  }, {
    name: 'Safari',
    re: /Version\/(\d+[\w.]*).*Safari/
  }];
  for (const {
    name,
    re
  } of rules) {
    const m = ua.match(re);
    if (m) {
      return {
        name,
        version: m[1]
      };
    }
  }
  return {
    name: undefined,
    version: undefined
  };
}
function detectOs(ua) {
  let m;
  if (m = ua.match(/Windows Phone(?: OS)? ([\d.]+)?/)) {
    return {
      name: 'Phone',
      version: m[1]
    };
  }
  if (m = ua.match(/Windows NT ([\d.]+)/)) {
    return {
      name: 'Windows',
      version: m[1]
    };
  }
  if (m = ua.match(/Android ([\d.]+)?/)) {
    return {
      name: 'Android',
      version: m[1]
    };
  }
  if (m = ua.match(/(?:iPhone|iPad|iPod).*OS (\d+[_\d]*)/)) {
    return {
      name: 'iOS',
      version: m[1].replace(/_/g, '.')
    };
  }
  if (m = ua.match(/Mac OS X (\d+[_.\d]*)/)) {
    return {
      name: 'Mac OS',
      version: m[1].replace(/_/g, '.')
    };
  }
  if (/BlackBerry|BB10/.test(ua)) {
    return {
      name: 'Blackberry',
      version: undefined
    };
  }
  if (/Linux|X11/.test(ua)) {
    return {
      name: 'Linux',
      version: undefined
    };
  }
  return {
    name: undefined,
    version: undefined
  };
}

export { parseUserAgent };
//# sourceMappingURL=user-agent.js.map
